import { createAsyncAction } from 'typesafe-actions';

import type { PricingControlSummary } from '@evenfinancial/originator-client';

import type { IsomorphicRequestPayload } from '../types';

import { PricingControlsActionType } from './actionTypes';

/**
 * Shared Actions
 */
export const getPricingControlsAction = createAsyncAction(
  PricingControlsActionType.GET_REQUEST,
  PricingControlsActionType.GET_SUCCESS,
  PricingControlsActionType.GET_FAILURE
)<IsomorphicRequestPayload, PricingControlSummary[], Error>();
